import url from '../url'
import headers from '../headers'

export default {
	getAll (context, user_uid) {
		return context.$http.get(
			`${url}/users/${user_uid}/subscriptions/`,
			headers.bearer()
		)
	},
	add (context, user_uid, model) {
		return context.$http.post(
			`${url}/users/${user_uid}/subscriptions/`,
			model,
			headers.bearer()
		)
	},
	getResume (context, user_uid) {
		return context.$http.get(
			`${url}/users/${user_uid}/subscriptions/resume/`,
			headers.bearer()
		)
	},
	getById (context, user_uid, sub_id) {
		return context.$http.get(
			`${url}/users/${user_uid}/subscriptions/${sub_id}/`,
			headers.bearer()
		)
	},
	editById (context, user_uid, sub_id, model) {
		return context.$http.put(
			`${url}/users/${user_uid}/subscriptions/${sub_id}/`,
			model,
			headers.bearer()
		)
	},
	admin: {
		getAll (context) {
			return context.$http.get(
				`${url}/admins/subscriptions/`,
				headers.bearer()
			)
		},
	},
	services: {
		getAll (context) {
			return context.$http.get(
				`${url}/services/`,
				headers.bearer()
			)
		},
		admin: {
			getAll (context) {
				return context.$http.get(
					`${url}/admins/services/`,
					headers.bearer()
				)
			},
			add (context, model) {
				return context.$http.post(
					`${url}/admins/services/`,
					model,
					headers.bearer()
				)
			},
			getById (context, service_id) {
				return context.$http.get(
					`${url}/admins/services/${service_id}/`,
					headers.bearer()
				)
			},
			editById (context, service_id, model) {
				return context.$http.put(
					`${url}/admins/services/${service_id}/`,
					model,
					headers.bearer()
				)
			}
		}
	},
	transactions: {
		getAll (context, user_uid, sub_id) {
			return context.$http.get(
				`${url}/users/${user_uid}/subscriptions/${sub_id}/transactions/`,
				headers.bearer()
			)
		},
		getById (context, user_uid, sub_id, trans_id) {
			return context.$http.get(
				`${url}/users/${user_uid}/subscriptions/${sub_id}/transactions/${trans_id}/`,
				headers.bearer()
			)
		},
		getLogsById (context, user_uid, sub_id, trans_id) {
			return context.$http.get(
				`${url}/users/${user_uid}/subscriptions/${sub_id}/transactions/${trans_id}/logs/`,
				headers.bearer()
			)
		}
	},
	budgets: {
		get (context, user_uid) {
			return context.$http.get(
				`${url}/users/${user_uid}/budget/`,
				headers.bearer()
			)
		}
	},
	operations: {
		getAll (context, user_uid) {
			return context.$http.get(
				`${url}/users/${user_uid}/budget/operations/`,
				headers.bearer()
			)
		},
		getById (context, user_uid, op_id) {
			return context.$http.get(
				`${url}/users/${user_uid}/budget/operations/${op_id}/`,
				headers.bearer()
			)
		}
	},
	paymentMethods: {
		getAll (context, user_uid) {
			return context.$http.get(
				`${url}/users/${user_uid}/budget/payment-methods/`,
				headers.bearer()
			)
		},
		add (context, user_uid, model) {
			return context.$http.post(
				`${url}/users/${user_uid}/budget/payment-methods/`,
				model,
				headers.bearer()
			)
		},
		getById (context, user_uid, method_id) {
			return context.$http.get(
				`${url}/users/${user_uid}/budget/payment-methods/${method_id}/`,
				headers.bearer()
			)
		},
		editById (context, user_uid, method_id, model) {
			return context.$http.put(
				`${url}/users/${user_uid}/budget/payment-methods/${method_id}/`,
				model,
				headers.bearer()
			)
		},
		deleteById (context, user_uid, method_id) {
			return context.$http.delete(
				`${url}/users/${user_uid}/budget/payment-methods/${method_id}/`,
				headers.bearer()
			)
		},
		setActiveById (context, user_uid, method_id) {
			return context.$http.put(
				`${url}/users/${user_uid}/budget/payment-methods/${method_id}/active/`,
				{},
				headers.bearer()
			)
		}
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/subscriptions.js